/**
 * The toast after something is put in a slot names the slot: « Ajouté au souper
 * de jeudi : Dumplings et légumes ».
 *
 * It used to repeat only what was typed (« Note : Dumplings et légumes »), so a
 * cook who had clicked the breakfast row by mistake was told nothing was wrong.
 * Both of one cook's non-recipe suppers landed on breakfast that way before
 * she noticed (8 Oct 2026). Naming the day and the meal is the cheapest check
 * there is.
 *
 * Pure `.ts` so Jest can import it.
 */

import { MEALS, dayFullKey, dayOf, rowOf } from './constants';

type Translate = (key: string, options?: Record<string, unknown>) => unknown;

export function placedInSlotMessage(t: Translate, sk: number, title: string): string {
  const day = String(t(dayFullKey(dayOf(sk))));
  const meal = String(t(MEALS[rowOf(sk)]?.labelKey ?? MEALS[2].labelKey));
  // Each language decides its own casing: French writes « de jeudi » in the
  // middle of a sentence, English keeps « Thursday ».
  return String(
    t('thisWeek.toastPlacedIn', {
      day,
      dayLower: day.toLowerCase(),
      meal: meal.toLowerCase(),
      title,
    }),
  );
}

/**
 * The slot a sheet is about to write to, for its header: « Jeudi · souper ».
 * The simple-meal form used to say « Jeudi » alone, on the last screen before
 * a supper was saved to breakfast (8 Oct 2026).
 */
export function slotLabel(t: Translate, sk: number): string {
  const day = String(t(dayFullKey(dayOf(sk))));
  const meal = String(t(MEALS[rowOf(sk)]?.labelKey ?? MEALS[2].labelKey));
  return `${day} · ${meal.toLowerCase()}`;
}
